<template>
  <div class="content">
		<template v-if="conType == 'login'">
			<div class="login_con">
				<div class="left_img">
					<img src="../assets/login/login_1.png" alt="">
				</div>
				
				<div class="login_form">
					<div class="login_top">
						用户登录
					</div>
					<div class="login_input">
						<img src="../assets/login/zhanghao.png"/>
						<input placeholder="请输入手机号" type="tel" v-model="phone"/>
					</div>
					<div class="login_input">
						<img src="../assets/login/mima.png"/>
						<input placeholder="请输入密码" :type="Type" v-model="password"/>
						<i class="el-icon-view" style="position: absolute;right: 0.20rem;font-size: 0.16rem;" @click="Show" :class="{ icon: Color }"></i>
					</div>
					<div class="check_xy">
						<el-checkbox v-model="checked"></el-checkbox>
						阅读并同意《用户协议》和《隐私政策》
					</div>
					<div class="login_btn" @click="passwordLogin">
						登录
					</div>
					<div class="login_tip">
						没有账号？去<span @click="conType = 'register'">注册</span>&nbsp;&nbsp;忘记密码？<span @click="conType = 'modify'">找回密码</span>
					</div>
				</div>
			</div>
		</template>
		<template v-if="conType == 'register'">
			<div class="register_con">
				<div class="left_img">
					<img src="../assets/login/login_2.png" alt="">
				</div>
				<div class="login_form">
					<div class="register_top">
						用户注册
					</div>
					<div class="div_step">
						<div class="step">
							<img v-if="step == '1'" src="../assets/login/first.png"/>
							<img v-else src="../assets/login/first_grey.png"/>
							<div>
								<!-- <div :style="{ 'color': step == '1' ? '#000000' : '#a9a9a9' }" class="text_top">步骤一</div> -->
								<div class="text_down">注册信息</div>
							</div>
						</div>
						<div class="step_line"></div>
						<div class="step">
							<img v-if="step == '2'" src="../assets/login/second.png"/>
							<img v-else src="../assets/login/second_grey.png"/>
							<div>
								<!-- <div :style="{ 'color': step == '2' ? '#000000' : '#a9a9a9' }" class="text_top">步骤二</div> -->
								<div class="text_down">个人信息</div>
							</div>
						</div>
						<div class="step_line"></div>
						<div class="step">
							<img v-if="step == '3'" src="../assets/login/thrid.png"/>
							<img v-else src="../assets/login/thrid_grey.png"/>
							<div>
								<!-- <div :style="{ 'color': step == '3' ? '#000000' : '#a9a9a9' }" class="text_top">步骤三</div> -->
								<div class="text_down">完成注册</div>
							</div>
						</div>
					</div>
					<template v-if="step == '1'">
						<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
							<div class="login_input">
								<img src="../assets/login/phone.png"/>
								<input v-model="user.phone" type="tel" placeholder="请输入手机号"/>
							</div>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
							<div class="yzm_div">
								<div class="login_input yzm_input">
									<img src="../assets/login/phone.png"/>
									<input v-model="user.code" type="number" placeholder="请输入验证码"/>
								</div>
								<div class="yzm_btn" @click="getCode">
									<template v-if="timer == ''">
										获取验证码
									</template>
									<template v-else>
										{{times}}S
									</template>
								</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
							<div class="login_input">
								<img src="../assets/login/mima.png"/>
								<input v-model="user.password" type="password" placeholder="密码至少6位，建议包含大小写字母"/>
							</div>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
							<div class="login_input">
								<img src="../assets/login/qrmima.png"/>
								<input v-model="user.confirmPW" type="password" placeholder="请再次输入密码"/>
							</div>
						</div>
						
					</template>
					<template v-if="step == '2'">
						<div class="step_2">
							<div style="display: flex;align-items: center;">
								<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
								<div class="login_input">
									<img src="../assets/login/zhanghao.png"/>
									<el-input v-model="user.name" placeholder="请输入姓名"></el-input>
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="width: 0.1rem;height: 0.48rem;margin-right: 0.1rem;"></div>
								<div class="login_input">
									<img src="../assets/login/sex.png"/>
									<el-select v-model="user.sex" placeholder="请选择用户性别" style="width: 100%;" clearable @clear="handleSexClear">
										<el-option label="男" value="1"></el-option>
										<el-option label="女" value="2"></el-option>
									</el-select>
								</div>
							</div>
							<!-- <div style="display: flex;align-items: center;">
								<div style="width: 0.1rem;height: 0.48rem;margin-right: 0.1rem;"></div>
								<div class="login_input">
									<img src="../assets/login/sex.png"/>
									<el-select v-model="user.deptId" placeholder="请选择所属单位" style="width: 100%;" @change="handleChange" clearable @clear="handleDeptIdClear">
										<template v-for="(item,key) in deptOption">
											<el-option :label="item.deptName" :value="item.id"></el-option>
										</template>
									</el-select>
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="width: 0.1rem;height: 0.48rem;margin-right: 0.1rem;"></div>
								<div class="xue_div">
									<div class="login_input xueduan_div">
										<img src="../assets/login/xueduan.png"/>
										<el-input v-model="deptCategory" readonly placeholder="教授学段"></el-input>
									</div>
									<div class="login_input xueduan_div">
										<img src="../assets/login/xueduan.png"/>
										<el-select v-model="user.discipline" placeholder="请选择教授学科" style="width: 100%;" clearable @clear="handleDisciplineClear">
											<template v-for="(item,key) in xuekeOption">
												<el-option :label="item.label" :value="item.value"  ></el-option>
											</template>
										</el-select>
									</div>
								</div>
							</div> -->
							<div style="display: flex;align-items: center;">
								<div style="width: 0.1rem;height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
									<div class="login_input">
										<img src="../assets/login/xueduan.png"/>
										<el-cascader
											v-model="user.regionId"
											placeholder="请选择单位所在地区"
											:props="props"
											style="width: 100%;"></el-cascader>
									</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
								<div class="login_input">
									<img src="../assets/login/xueduan.png"/>
									<el-input v-model="user.unitName" placeholder="请输入单位名称"></el-input>
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="width: 0.1rem;height: 0.48rem;margin-right: 0.1rem;"></div>
								<div class="login_input">
									<img src="../assets/login/sex.png"/>
									<el-select v-model="user.politicalOutlook" placeholder="请选择政治面貌" style="width: 100%;" clearable @clear="handlePoliticalOutlookClear">
										<template v-for="(item,key) in politicalOption">
											<el-option :label="item.dictValue" :value="item.dictKey"></el-option>
										</template>
									</el-select>
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
								<div class="login_input">
									<img src="../assets/login/email.png"/>
									<el-input v-model="user.email" placeholder="请输入电子邮箱地址"></el-input>
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
								<div class="login_input">
									<img src="../assets/login/sex.png"/>
									<el-input v-model="user.idNumber" placeholder="请输入身份证"></el-input>
								</div>
							</div>
						</div>
					</template>
					<template v-if="step == '3'">
						<div class="success_div">
							<p>恭喜您完成注册！</p>
							<!-- 请等待管理员审核或联系{{telephone}} -->
						</div>
					</template>
					<div class="check_xy" v-if="step == '1'">
						<el-checkbox v-model="checked"></el-checkbox>
						阅读并同意《用户协议》和《隐私政策》
					</div>
					<div class="login_btn" @click="goNext">
						{{step == '3' ? '关闭' : '下一步'}}
					</div>
					<div class="login_tip" v-if="step == '1'">
						已有账号？去<span @click="conType = 'login'">登录</span>
					</div>
				</div>
			</div>
		</template>
		<template v-if="conType == 'modify'">
			<div class="modify_form">
				<div class="login_top">
					找回密码
				</div>
				<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
				<div class="login_input">
					<img src="../assets/login/zhanghao.png"/>
					<input placeholder="请输入手机号" type="tel" v-model="user.phone"/>
				</div>
				</div>
				<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
							<div class="yzm_div">
								<div class="login_input yzm_input">
									<img src="../assets/login/phone.png"/>
									<input v-model="user.code" type="number" placeholder="请输入验证码"/>
								</div>
								<div class="yzm_btn" @click="getCode">
									<template v-if="timer == ''">
										获取验证码
									</template>
									<template v-else>
										{{times}}S
									</template>
								</div>
							</div>
						</div>
				<!-- <div class="login_input">
					<img src="../assets/login/mima.png"/>
					<input placeholder="请输入原密码" type="password" v-model="oldPassword"/>
				</div> -->
				<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
				<div class="login_input">
					<img src="../assets/login/mima.png"/>
					<input placeholder="请输入新密码" type="password" v-model="newPassword"/>
				</div>
				</div>
				<div style="display: flex;align-items: center;">
							<div style="height: 0.48rem;margin-right: 0.1rem;"><span style="color: red;font-size: 0.20rem;">*</span></div>
				<div class="login_input">
					<img src="../assets/login/mima.png"/>
					<input placeholder="请确认新密码" type="password" v-model="newPassword1"/>
				</div>
				</div>
				<!-- <div class="check_xy">
					<el-checkbox v-model="checked"></el-checkbox>
					阅读并同意《用户协议》和《隐私政策》
				</div> -->
				<div class="login_btn" @click="passwordUpdate">
					确定
				</div>
				<div class="login_tip">
					已有账号？去<span @click="conType = 'login'">登录</span>
				</div>
			</div>
		</template>
  </div>
</template>

<script>
	import { Message } from 'element-ui';
	import md5 from 'js-md5'
export default {
  name: "login",
  props: {
	modifyIndex: {
		type:String,
		default:'login'
	},
	
  },
  data() {
	const vm = this;
    return {
			conType: 'login',
			checked: true,
			step: 1,
			phone: '',
			password: '',
			user:{
				phone: '',
				code: '',
				codeId: '',
				password: '',
				confirmPW: '',
				name: '',
				sex: '',
				deptId: '',
				county:'',
				deptName: '',
				deptCategory: '',
				discipline: '',
				politicalOutlook: '',
				email: '',
				regionId: '',
				unitName: '',
			},
			deptCategory: '',
			deptOption: [],
			xueduanOption: [],
			xuekeOption: [],
			politicalOption: [],
			timer:'',
			times: 60,
			props:{
				nodeKey: 'id',
				lazy: true,
				clearable: true,
				// 使用箭头函数，确保内部的 this 指向当前组件实例
				lazyLoad: (node, resolve) => {
					const parentCode = node.level === 0 ? '62' : node.data.id;
					vm.$get('blade-system/region/lazy-tree', {parentCode:parentCode})
					.then((res) => {
						console.log(res);
						const children = res.data.map(item => ({
							id: item.id,
							value: item.value,
							label: item.title,
							parentId: item.parentId,
							leaf: !item.hasChildren,
						}));
						resolve(children);
					})
					.catch((error) => {
						console.error('加载树节点失败', error);
						resolve([]);
					});
				}
			},
			telephone: '',
			oldPassword:'',
			newPassword:'',
			newPassword1:'',
			userInfo:'',
			
			Type: "password",
			Color: false,
			options:[]
    };
  },
  

  watch:{

	modifyIndex:{
		handler(newDate, oldVal) {
			console.log('newDate=>',newDate);
			this.conType = newDate ? newDate : 'login'
		},
		immediate: true
	}
  },
  created(){
	//this.conType = this.modifyIndex;
	if(sessionStorage.getItem('userInfo')){
		let form = sessionStorage.getItem('userInfo')
		this.userInfo = JSON.parse(form)
	}else{
		this.userInfo = ''
	}
  },
  mounted() {
	  this.getOption();
  },
  methods: {
		Show() {
			// 点击改变input框的展示方式
			this.Type = this.Type === "password" ? "text" : "password";
			this.Color = !this.Color;
		},
		goNext(){
			if(this.step != '3'){
				if(this.step == '1'){
					if(!this.user.phone){
						this.$message({
						  message: '手机号不能为空',
						});
						return;
					}
					if(!this.checkMobile(this.user.phone)){
						this.$message({
						  message: '手机号格式错误',
						});
						return;
					}
					if(!this.user.code){
						this.$message({
						  message: '验证码不能为空',
						});
						return;
					}
					if(!this.checkPassword(this.user.password)){
						this.$message({
						  message: '密码至少6位，建议包含大小写字母',
						});
						return;
					}
					if(this.user.password != this.user.confirmPW){
						this.$message({
						  message: '两次密码不一致',
						});
						return;
					}
				}
				if(this.step == '2'){
					this.goRegister();
					return;
				}
				this.step++
			}else{
				this.$emit('fatherFunction', 'home')
			}
		},
		//校验手机格式
		checkMobile(mobile){
		  return RegExp(/^1[3456789]\d{9}$/).test(mobile);
		},
		checkPassword(password){
			const isTrue = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9~!@&%#_]{6,}$/;
			return isTrue.test(password);
		},
		checkEmail(email){
			const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
			return mailReg.test(email);
		},
		//查询字典
		getOption(){
			//查询部门
			this.$get('/blade-system/dept/getDeptList',{})
			.then((res) => {
				console.log(res);
				if(res.code == '200'){
					this.deptOption = res.data
				}else{
					this.$message({
					  message: res.msg,
					});
				}
			})
			//查询政治面貌
			this.$get('/blade-system/dict-biz/dictionary?code=Political&tenantId=000000',{})
			.then((res) => {
				console.log(res);
				if(res.code == '200'){
					this.politicalOption = res.data
				}else{
					this.$message({
					  message: res.msg,
					});
				}
			})
		},
		handleChange(e){
			console.log(e)
			for (let i = 0; i < this.deptOption.length; i++) {
				if(e == this.deptOption[i].id){
					this.deptCategory = this.deptOption[i].deptCategory == 1 ? '小学' : this.deptOption[i].deptCategory == 2 ? '初中' : '高中'
					this.user.deptCategory = this.deptOption[i].deptCategory
					//根据选中单位查询学科
					this.$get('/user/CourseClassUserInfo/getDisciplineByPeriod?period=' + this.deptCategory,{})
					.then((res) => {
						console.log(res);
						if(res.code == '200'){
							this.xuekeOption = res.data.map(item => {
								return { value: `${item}`, label: `${item}` };
							});
							console.log('this.xuekeOption',this.xuekeOption)
						}else{
							this.$message({
							  message: res.msg,
							});
						}
					})
				}
			}
		},
		handleSexClear(){
			this.user.sex = '';
		},
		handleDeptIdClear(){
			this.user.deptId = '';
			this.user.deptCategory = ''
			this.deptCategory = ''
		},
		handleDisciplineClear(){
			this.user.discipline = ''
		},
		handlePoliticalOutlookClear(){
			this.user.politicalOutlook = ''
		},
		//获取验证码
				//获取验证码
		getCode(){
			if(!this.checkMobile(this.user.phone)){
				this.$message({
				  message: '手机号格式错误',
				});
				return;
			}

			// 1. 先调用新接口检查手机号状态
			this.$post('/user/registerInfo/checkPhone', {
				phone: this.user.phone
			}).then((res) => {
				if (res.code == 200) {
					const isRegistered = res.data; // true: 已注册, false: 未注册
					// 2. 根据当前业务场景判断是否允许发送验证码
					if (this.conType === 'register') {
						// 注册场景：手机号必须【未注册】
						if (isRegistered) {
							this.$message({
								message: '该手机号已注册，请直接登录',
								type: 'warning'
							});
							return;
						}
					} else if (this.conType === 'modify') {
						// 找回密码场景：手机号必须【已注册】
						if (!isRegistered) {
							this.$message({
								message: '该手机号未注册，请先注册',
								type: 'warning'
							});
							return;
						}
					}

					// 3. 校验通过，执行发送短信逻辑
					this.sendSmsRequest();

				} else {
					this.$message({
						message: res.msg || '手机号校验失败',
						type: 'error'
					});
				}
			}).catch((error) => {
				this.$message({
					message: '网络请求异常',
					type: 'error'
				});
			});
		},

		// 提取发送短信的具体请求逻辑，避免代码重复和递归死循环
		sendSmsRequest() {
			this.$post('/blade-resource/sms/endpoint/send-validate?phone=' + this.user.phone, {})
				.then((res) => {
					console.log(res);
					if (res.code == '200') {
						this.$message({
							message: '验证码发送成功',
							type: 'success'
						});
						this.user.codeId = res.data.id;
						
						// 启动倒计时
						this.times = 60;
						this.timer = setInterval(() => {
							this.times--;
							if (this.times <= 0) {
								clearInterval(this.timer);
								this.times = 60;
								this.timer = '';
							}
						}, 1000);
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				})
				.catch((error) => {
					this.$message({
						message: '验证码发送失败',
						type: 'error'
					});
				});
		},
		//手机号密码登录
		passwordLogin(){
			if(!this.checked){
				this.$message({
				  message: '请先阅读并同意《用户协议》和《隐私政策》',
				});
				return;
			}
			if(!this.checkMobile(this.phone)){
				this.$message({
				  message: '手机号格式错误',
				});
				return;
			}
			if(this.password == ''){
				this.$message({
				  message: '密码不能为空',
				});
				return;
			}
			let obj = {
				username : this.phone,
				password: this.password,
				tenantId: '000000',
			}
			this.$post('/blade-auth/oauth/token' + '?password=' + md5(this.password) + '&tenantId=000000&username=' + this.phone,{})
				.then((res) => {
					console.log('登录',res);
					if(res.access_token){
						//保存用户信息
						this.$store.dispatch('userLogin',res)
						this.$message({
						  message: '登录成功',
						  type: 'success'
						});
						this.phone = '';
						this.password = '';
						this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
						this.$emit('fatherFunction', 'home')
					}else{
						this.$message({
						  message: res.msg ? res.msg : res.error_description,
						});
					}
				})
		},
		passwordUpdate(){
			
			
			// if(this.oldPassword == ''){
			// 	this.$message({
			// 	  message: '密码不能为空',
			// 	});
			// 	return;
			// }
			// if(this.oldPassword == this.newPassword){
			// 	this.$message({
			// 	  message: '请输入新的密码',
			// 	});
			// 	return;
			// }、
			if(!this.user.phone){
				this.$message({
				  message: '手机号不能为空',
				});
				return;
			}
			if(!this.checkMobile(this.user.phone)){
				this.$message({
				  message: '手机号格式错误',
				});
				return;
			}
			if(!this.user.code){
				this.$message({
					 message: '验证码不能为空',
				});
				return;
			}
			if(this.newPassword1 != this.newPassword){
				this.$message({
				  message: '两次密码不一致',
				});
				return;
			}
			if(this.newPassword == ''){
				this.$message({
				  message: '请输入新的密码',
				});
				return;
			}
			if(this.newPassword1 == ''){
				this.$message({
				  message: '请确认新的密码',
				});
				return;
			}
			if(!this.checkPassword(this.newPassword)){
				this.$message({
					message: '密码至少6位，建议包含大小写字母',
				});
				return;
			}
			let form = {
				password:this.newPassword,
				confirmPW:this.newPassword1,
				phone:this.user.phone,
				code:this.user.code,
				codeId:this.user.codeId,
			}
			this.$post('/user/registerInfo/resetPassword',form)
				.then((res) => {
					console.log(res);
					if(res.code == 200){
						this.$store.dispatch('userLogout')
						this.$message({
						  message: res.msg,
						  type: 'success'
						});
						this.user.phone = ''
						this.user.code = ''
						this.newPassword = ''
						this.newPassword1 = ''
					}else{
						this.$message({
							type: 'error',
						  message: res.msg,
						});
					}
					
				}).catch((error) => {
					this.$message({
						type: 'error',
					  	message: '请求失败',
					});
				})
		},
		//注册
		goRegister(){
			
			if(!this.user.name){
				this.$message({
				  message: '用户姓名不能为空',
				});
				return;
			}
			if(!this.user.regionId){
				this.$message({
				  message: '所在地区不能为空',
				});
				return;
			}
			if(!this.user.unitName){
				this.$message({
				  message: '单位名称不能为空',
				});
				return;
			}
			if(!this.checkEmail(this.user.email)){
				this.$message({
				  message: '邮箱格式错误',
				});
				return;
			}
			if(!this.validatorIdCard(this.user.idNumber)){
				return
			}
			this.$post('/user/registerInfo/register',this.user)
				.then((res) => {
					console.log(res);
					if(res.code == '200'){
						this.telephone = res.data[0].value
						this.step++
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
		},
		validatorIdCard ( IDCard) {
        // 15位和18位身份证号码的正则表达式
        const regIDCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
        // 如果通过该验证，说明身份证格式正确，但准确性还需计算
        if (regIDCard.test(IDCard)) {
          if (IDCard.length === 18) {
            const IDCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]// 将前17位加权因子保存在数组里
            const idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2] // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
            let idCardWiSum = 0 // 用来保存前17位各自乖以加权因子后的总和
            for (let i = 0; i < 17; i++) {
              idCardWiSum += IDCard.substring(i, i + 1) * IDCardWi[i]
            }
            const idCardMod = idCardWiSum % 11 // 计算出校验码所在数组的位置
            const idCardLast = IDCard.substring(17) // 得到最后一位身份证号码
            // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod === 2) {
              if (idCardLast === 'X' || idCardLast === 'x') {
                return true
              } else {
                console.log(Number(idCardLast), idCardY[idCardMod])
				this.$message({
				  message: '身份证号码错误！',
				})
				return false
              }
            } else {
              // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
              if (Number(idCardLast) === idCardY[idCardMod]) {
               return true
              } else {
                console.log(Number(idCardLast), idCardY[idCardMod])
				this.$message({
				  message: '身份证号码错误！',
				})
				return false
              }
            }
          }
        } else {
		  this.$message({
				  message: '身份证格式不正确',
				})
			return false
        }
      }
  },
};
</script>

<style scoped lang="less">
	.content{
		background-color: #EBEFF1;padding-top: 0.3rem;padding-bottom: 0.3rem;padding-left: 1.2rem;padding-right: 1.2rem;
		display: flex;
		.login_con{
			width: 12rem;height: 5.25rem;border-radius: 0.04rem;background: #FFF;display: flex;align-items: center;
			margin: 0 auto;
			.left_img{
				width: 50%;
				height: 100%;
				img{
					width: 4.02rem;
					height: 4.63rem;
					margin-left: 1.21rem;
					margin-top: 0.35rem;
				}
			}
			.login_form{
				width: 50%;
				display: flex;flex-direction: column;align-items: center;
				.login_top{
					color: #000000;text-align: center;font-family: Alibaba PuHuiTi;font-size: 0.24rem;margin-bottom: 0.6rem;
				}
			}
			
		}
		.login_input{
			display: flex;width: 4.44rem;height: 0.32rem;padding: 0.08rem 0.12rem;align-items: center;border-radius: 0.02rem;
			border: 1px solid #D9D9D9;background: #FFF;margin-bottom: 0.3rem;position: relative;
			img{
				width: 0.16rem;height: 0.16rem;margin-right: 0.16rem;
			}
			input{
				border: none;outline: none;width: 3rem;height: 0.24rem;font-size: 0.16rem;
			}
		}
		
		.check_xy{
			color: #000000d9;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 400;display: flex;align-items: center;
			margin-bottom: 0.62rem;width: 4.68rem;
		}
		.login_btn{
			display: flex;width: 1.24rem;height: 0.28rem;padding: 0.06rem 0.15rem;cursor: pointer;
			justify-content: center;align-items: center;border-radius: 0.02rem;border: 1px solid #134F97;
			background: #134F97;color: #ffffff;font-family: Alibaba PuHuiTi;font-size: 0.16rem;margin-bottom: 0.3rem;
		}
		.yzm_btn{
			display: flex;width: 1.02rem;height: 0.4rem;cursor: pointer;
			justify-content: center;align-items: center;border-radius: 0.02rem;
			background: #2072D2;color: #ffffff;font-family: Alibaba PuHuiTi;font-size: 0.16rem;
		}
		.login_tip{
			color: #a9a9a9;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 400;
			span{
				color: #2072d2;cursor: pointer;
			}
		}
		.register_con{
			width: 12rem;border-radius: 0.04rem;background: #FFF;padding: 0.6rem 0;
			display: flex;align-items: center;margin: 0 auto;
			.left_img{
				width: 50%;
				height: 100%;
				display: flex;
				align-items: center;
				img{
					width: 4.02rem;
					height: 4.63rem;
					margin-left: 1.21rem;
				}
			}
			.login_form{
				width: 50%;
				display: flex;flex-direction: column;align-items: center;
				.register_top{
					color: #000000;text-align: center;font-family: Alibaba PuHuiTi;font-size: 0.24rem;margin-bottom: 0.3rem;
				}
				.div_step{
					display: flex;align-items: center;margin-bottom: 0.3rem;
					.step{
						display: flex;align-items: center;
						img{
							width: 0.39rem;height: 0.39rem;margin-right: 0.08rem;
						}
						.text_top{
							font-family: Alibaba PuHuiTi;font-size: 0.16rem;margin-bottom: 0.07rem;
						}
						.text_down{
							color: #24a1f5;
							font-family: "Alibaba PuHuiTi";
							font-size: 0.24rem;
							font-style: normal;
 							font-weight: 500;
							// color: #a9a9a9;
							// font-family: Alibaba PuHuiTi;
							// font-size: 0.14rem;
						}
					}
					.step_line{
						width: 0.4rem;height: 0.01rem;margin: 0 0.16rem;background: #a9a9a9;
					}
				}
			}
			
		}
		.yzm_div{
			display: flex;align-items: center;margin-bottom: 0.3rem;
		}
		.yzm_input{
			width: 3.22rem;margin-right: 0.2rem;margin-bottom: 0;
		}
		.xue_div{
			display: flex;align-items: center;margin-bottom: 0.3rem;justify-content: space-around;width: 4.74rem;
		}
		.xueduan_div{
			width: 2.04rem;margin-bottom: 0;
		}
		.success_div{
			color: #000000;text-align: center;font-family: Alibaba PuHuiTi;font-size: 0.24rem;font-weight: 500;margin-top: 0.3rem;margin-bottom: 0.6rem;
			p{
				margin-bottom: 0.3rem;
			}
		}
	}
	.modify_form{
		width: 12rem;height: 5.25rem;border-radius: 0.04rem;background: #FFF;
		display: flex;flex-direction: column;align-items: center;margin: 0 auto;
		.login_top{
			color: #000000;text-align: center;font-family: Alibaba PuHuiTi;font-size: 0.24rem;margin-bottom: 0.6rem;margin-top: 0.2rem;
		}
		.div_step{
			display: flex;align-items: center;margin-bottom: 0.3rem;
			.step{
				display: flex;align-items: center;
				img{
					width: 0.39rem;height: 0.39rem;margin-right: 0.08rem;
				}
				.text_top{
					font-family: Alibaba PuHuiTi;font-size: 0.16rem;margin-bottom: 0.07rem;
				}
				.text_down{
					color: #24a1f5;
					font-family: "Alibaba PuHuiTi";
					font-size: 0.24rem;
					font-style: normal;
					font-weight: 500;
					// color: #a9a9a9;
					// font-family: Alibaba PuHuiTi;
					// font-size: 0.14rem;
				}
			}
			.step_line{
				width: 0.4rem;height: 0.01rem;margin: 0 0.16rem;background: #a9a9a9;
			}
		}
	}
	/deep/ .el-checkbox__inner{
		width: 0.16rem;
		height: 0.16rem;
		margin-right: 0.08rem;
	}
	/deep/ .el-checkbox__inner::after{
		width: 0.04rem;
		top: 0.03rem;
	}
	/deep/.el-input__inner{
		border: none;
		font-size: 0.16rem;
		width: 100%;
	}
	.el-select-dropdown__item{
		font-size: 0.16rem;
	}
	/deep/ .step_2 .login_input .el-input .el-input__inner{
		border: 1px solid #ffffff !important;
	}
</style>



// WEBPACK FOOTER //
// src/index/login.vue